module.exports = __webpack_public_path__ + "img/2.4af76eea.png";